import Phaser from "phaser";

type ImpactTarget = Phaser.GameObjects.GameObject &
  Phaser.GameObjects.Components.Transform &
  Phaser.GameObjects.Components.AlphaSingle & {
    getBounds(): Phaser.Geom.Rectangle;
    depth?: number;
  };

type ImpactState = {
  baseScaleX: number;
  baseScaleY: number;
  baseAlpha: number;
  scaleTween?: Phaser.Tweens.Tween;
};

const TARGET_STATE = new WeakMap<ImpactTarget, ImpactState>();
const FLASH_DURATION = 120;
const PUNCH_SCALE = 1.05;
const FLASH_ALPHA = 0.65;
const OVERLAY_DEPTH_OFFSET = 40;

export function playImpactFlash(scene: Phaser.Scene, target: ImpactTarget) {
  const bounds = target.getBounds();
  const state =
    TARGET_STATE.get(target) ??
    ({
      baseScaleX: (target.scaleX ?? 1) as number,
      baseScaleY: (target.scaleY ?? 1) as number,
      baseAlpha: (target.alpha ?? 1) as number,
    } satisfies ImpactState);

  state.scaleTween?.stop();
  target.setScale(state.baseScaleX, state.baseScaleY);
  target.setAlpha(state.baseAlpha);

  const overlay = scene.add.rectangle(
    bounds.centerX,
    bounds.centerY,
    bounds.width,
    bounds.height,
    0xffffff,
    FLASH_ALPHA
  );
  overlay.setDepth((target.depth ?? 0) + OVERLAY_DEPTH_OFFSET);

  scene.tweens.add({
    targets: overlay,
    alpha: 0,
    duration: FLASH_DURATION,
    ease: "Sine.easeOut",
    onComplete: () => overlay.destroy(),
  });

  const scaleTween = scene.tweens.add({
    targets: target,
    scaleX: state.baseScaleX * PUNCH_SCALE,
    scaleY: state.baseScaleY * PUNCH_SCALE,
    duration: FLASH_DURATION,
    ease: "Cubic.easeOut",
    yoyo: true,
    onComplete: () => {
      target.setScale(state.baseScaleX, state.baseScaleY);
      target.setAlpha(state.baseAlpha);
    },
  });

  TARGET_STATE.set(target, { ...state, scaleTween });
}
